/* eslint-disable */
export default {
  tollFree: 'Numéro sans frais',
  rcvPmiMeetingTitle: 'Réunion vidéo de {extensionName}',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
